export default __webpack_public_path__ + "static/media/database.b07e06e5.svg";